import React from 'react';
import { BiInfoCircle } from 'react-icons/bi';
import { TIPOS_EDICAO, rotuloTipoEdicao } from './edicaoValor';

// Campos do evento gerado por uma edição manual de valor em contrato ATIVO
// (09/out/2026): tipo (sugerido pelo caso), data de vigência, motivo e nº do termo.
// `permitidos` = tipos coerentes com o sinal da alteração; `sugerido` = default.
const inputCls = 'w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 px-3 py-2 text-gray-900 dark:text-gray-100 focus:border-vox-blue-500 focus:ring-2 focus:ring-vox-blue-500';
const labelCls = 'block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1';

const CamposEventoEdicao = ({ evento, onChange, sugerido, permitidos = TIPOS_EDICAO, idPrefixo = 'edicao', aviso }) => {
    const set = (campo, valor) => onChange({ ...evento, [campo]: valor });
    return (
        <div className='space-y-3 rounded-lg border border-amber-300 bg-amber-50 p-4 dark:border-amber-800 dark:bg-amber-950/30'>
            <p className='flex items-start gap-2 text-sm text-amber-900 dark:text-amber-100'>
                <BiInfoCircle className='mt-0.5 h-4 w-4 shrink-0' aria-hidden='true' />
                <span>{aviso || 'Contrato ativo: a alteração de valor vira um evento na timeline do contrato (com proporcional a partir da data de vigência).'}</span>
            </p>
            <div className='grid grid-cols-1 gap-3 sm:grid-cols-2'>
                <div>
                    <label htmlFor={`${idPrefixo}-tipo`} className={labelCls}>Tipo do evento</label>
                    <select id={`${idPrefixo}-tipo`} className={inputCls} value={evento.tipo || ''}
                        onChange={(e) => set('tipo', e.target.value)}>
                        <option value=''>{sugerido ? `Automático (${rotuloTipoEdicao(sugerido)})` : 'Automático'}</option>
                        {permitidos.map((t) => <option key={t.valor} value={t.valor}>{t.label}</option>)}
                    </select>
                </div>
                <div>
                    <label htmlFor={`${idPrefixo}-data`} className={labelCls}>Data de vigência <span className='text-red-600'>*</span></label>
                    <input id={`${idPrefixo}-data`} type='date' className={inputCls} value={evento.data_evento || ''}
                        onChange={(e) => set('data_evento', e.target.value)} />
                </div>
                <div>
                    <label htmlFor={`${idPrefixo}-termo`} className={labelCls}>Nº do termo</label>
                    <input id={`${idPrefixo}-termo`} type='text' maxLength={50} className={inputCls} value={evento.numero_termo || ''}
                        onChange={(e) => set('numero_termo', e.target.value)} placeholder='Ex.: 2º Termo Aditivo 15/2026' />
                </div>
                <div className='sm:col-span-2'>
                    <label htmlFor={`${idPrefixo}-motivo`} className={labelCls}>Motivo <span className='text-red-600'>*</span></label>
                    <textarea id={`${idPrefixo}-motivo`} rows={2} className={inputCls} value={evento.motivo || ''}
                        onChange={(e) => set('motivo', e.target.value)} placeholder='Ex.: 2º Termo Aditivo — prazo e valor' />
                </div>
            </div>
        </div>
    );
};

export default CamposEventoEdicao;
